import {
  RugbyLeagueEventDetailId,
  RugbyLeagueEventStatusId,
} from '@collector/sportsapi-client-legacy'

import {
  createRugbyEventClockConfig,
  rugbyClockFixed,
  rugbyClockRunning,
  rugbyClockTiming,
  type RugbyStatusClockRule,
} from '../../configuration'

const t = rugbyClockTiming

const statusClock: Partial<
  Record<RugbyLeagueEventStatusId, RugbyStatusClockRule>
> = {
  [RugbyLeagueEventStatusId.NotStarted]: rugbyClockFixed(t.fromMatchStart),
  [RugbyLeagueEventStatusId.FirstHalf]: rugbyClockRunning(
    t.fromMatchStart,
    t.periodLength,
  ),
  [RugbyLeagueEventStatusId.Halftime]: rugbyClockFixed(t.periodLength),
  [RugbyLeagueEventStatusId.FinishedRegularTime]: rugbyClockFixed(
    t.afterFirstHalf,
  ),
  [RugbyLeagueEventStatusId.WaitingForExtratime]: rugbyClockFixed(
    t.afterFirstHalf,
  ),
  [RugbyLeagueEventStatusId.ExtratimeHalftime]: rugbyClockFixed(
    t.afterExtraFirstHalf,
  ),
  [RugbyLeagueEventStatusId.FinishedAfterExtratime]: rugbyClockFixed(
    t.afterExtraTime,
  ),
  [RugbyLeagueEventStatusId.WaitingForPenalty]: rugbyClockFixed(
    t.penaltyPhaseEnd,
  ),
  [RugbyLeagueEventStatusId.Penalties]: rugbyClockFixed(t.penaltyPhaseEnd),
  [RugbyLeagueEventStatusId.FinishedAfterPenalties]: rugbyClockFixed(
    t.penaltyPhaseEnd,
  ),
  [RugbyLeagueEventStatusId.SecondHalf]: rugbyClockRunning(
    t.periodLength,
    t.afterFirstHalf,
  ),
  [RugbyLeagueEventStatusId.ExtratimeFirstHalf]: rugbyClockRunning(
    t.afterFirstHalf,
    (timing) => timing.periodLength * 2 + timing.extraPeriodLength,
  ),
  [RugbyLeagueEventStatusId.ExtratimeSecondHalf]: rugbyClockRunning(
    t.afterExtraFirstHalf,
    t.afterExtraTime,
  ),
}

export const {
  getEventStatusPeriodLengthMinutes,
  getEventPeriodStartOffsetMinutes,
  getEventClockSeconds,
  isValidEventClockTime,
  getEventClockTime,
} = createRugbyEventClockConfig(statusClock)

export const extraTimeDetailId =
  RugbyLeagueEventDetailId.FirstExtraHalfStartDate
